module.exports = __webpack_public_path__ + "img/child.3c995a99.svg";